import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as productActions from "../../../../../actions/productAction";

import DEFINE, { DETAIL_ACTIONS, FEATURE_FLAGS, PATHS } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Tooltip, Icon } from 'antd';
import Input from '../../../common/component/Input';
import TextArea from '../../../common/component/TextArea';
import $ from 'jquery'
import { cloneDeep, merge } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Product from '../../../../../models/Product';

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: merge(new Product(), { isEnabled: true }),
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
};

class ActionComponent extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetItemProduct({ id: match.params.id, props: this.props });
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.product.name`)),
                }
            };
            if(this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            let valueValidate = {};
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.products.isSubmit,
            isGetItem: nextProps.products.isGetItem,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.products.dataUpdate !== prevProps.products.dataUpdate) {
            this.setState({
                data: this.props.products.dataUpdate,
            })
        }
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            data: merge(this.state.data, {
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            })
        });
        this.validation(params.name, true)
    };

    onShowTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.PRODUCT.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
        const translateFunction = data.translate.id ? this.props.updateProductTranslate : this.props.createProductTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        this.props.deleteProductCategoryTranslate(data, { id: data.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                let dataCreate = this.state.data;
                this.props.onCreateProduct({ data: dataCreate, props: this.props });
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE) {
                let dataUpdate = this.state.data;
                dataUpdate.id = this.state.data.id;
                this.props.onUpdateProduct({ data: dataUpdate, props: this.props });
            } else if(this.state.action === DETAIL_ACTIONS.TRANSLATE){
                this.onSaveTranslate()
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action } = this.state;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath="products"
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.product.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.product.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange({name: 'languageCode', value: language.code})}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('products', this.props)}
                            onChangeActive={this.onChange}
                            submitButtonRight={true}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-6 offset-md-3 mt-3">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.product.name`)}
                                    >
                                        <Input placeholder="" type="text"
                                            className="form-control"
                                            name="name" onChange={this.onChange}
                                            value={Func.checkUndefine(data.name)} />
                                    </HMS.FormWrapperInputComponent>

                                    <HMS.FormWrapperInputComponent
                                        labelTitle={t(`item.product.description`)}
                                    >
                                        <TextArea placeholder=""
                                            className="form-control"
                                            name="description" onChange={this.onChange}
                                            value={Func.checkUndefine(data.description)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        products: state.productReducer,
        file: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateProduct: (params) => {
            dispatch(action.createProductAction(params))
        },
        onUpdateProduct: (id) => {
            dispatch(action.updateProductAction(id))
        },
        onGetItemProduct: (id) => {
            dispatch(action.getUpdateProductAction(id))
        },
        createProductTranslate: (product, language) => dispatch(productActions.createProductTranslate(product, language)),
        updateProductTranslate: (product, language) => dispatch(productActions.updateProductTranslate(product, language)),
        deleteProductTranslate: (product, refreshParams) => dispatch(productActions.deleteProductTranslate(product, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
